import { Signal } from "../core/Signal.js";

export const Tick = Signal.create<[]>();

const onEnterFrame = () => {
    Tick.dispatch();
    requestAnimationFrame(onEnterFrame);
};
requestAnimationFrame(onEnterFrame);
